export type KeyValue<T> = { [key: string]: T | null | undefined };

export interface PaginatedSearch {
    filter?: string;
    page: number;
    size: number;
}

export interface PaginatedSearchResult<T> {
    page: number,
    size: number,
    total: number,
    items: T[]
}

export interface LazyLoadedSearch {
    size: number;
    from: number;
    filter: string;
}

export interface UserRowData {
    language?: string,
    email: string,
    firstName: string,
    lastName: string
}

export interface UserItem {
    id: number,
    data: UserRowData,
    errors: KeyValue<string>,
}

export interface UserToAdd {
    email: string,
    firstName: string,
    lastName: string,
    language: string
}

export enum FormStatus {
    none,
    processing,
    successful,
    failed,
    deletable
}

export interface WithErrorAndProcessingStatus {
    processingStatus: FormStatus,
    errorMessage: string
}
